/**
    Higher order component of PageShell for global ad initialization of all ads on current page.  Responsible for 'refreshing'
    all ads that are visible on initial page load
    The code for the global 'admgr' is here https://code.espn.com/webdev/score/blob/develop/static/js/ads/admgr.js
    You can see the ad requests in the console by filtering on 'pubads'
*/
import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import hoistStatics from 'hoist-non-react-statics';
import { persistentFlagsSelector } from 'common/selectors/flagsSelector';
import AdManager from './AdManager';

function connectAdInitializer(WrappedComponent) {
    class AdInitializer extends Component {
        constructor(props) {
            super(props);
            this.watchAdManager = new AdManager(props);
        }

        getChildContext() {
            return {
                watchAdManager: this.watchAdManager
            };
        }

        componentDidMount() {
            if (window.admgr) {
                // patch to accept config object and filter out non-refreshable in-page ads
                window.admgr.getGPTArray = function getGPTArray(obj = {}) {
                    const slots = window.admgr.getGPTSlots() || {};
                    const arr = [];
                    let slot;

                    Object.keys(slots).forEach(key => {
                        slot = slots[key];
                        if (obj.independent !== false || slot.isIndependent !== true) {
                            if (obj.inPage === true && slot.isOutOfPage !== true && slot.refreshable) {
                                arr.push(slot);
                            } else if (obj.outOfPage === true && (slot.isOutOfPage === true || slot.isCatExclusion === true)) {
                                arr.push(slot);
                            } else if (obj.inPage !== true && obj.outOfPage !== true) {
                                arr.push(slot);
                            }
                        }
                    });

                    return arr;
                };
                // patch to use the patched `getGPTArray`, original API uses the local `getGPTArray` so can't use as is.
                window.admgr.refreshInPageAdSlots = function refreshInPageAdSlots() {
                    const arr = window.admgr.getGPTArray({ inPage: true, independent: false });
                    window.googletag.cmd.push(() => {
                        window.googletag.pubads().refresh(arr);
                    });
                };
                this.watchAdManager.adManager = window.admgr;
            }
        }

        componentWillReceiveProps(nextProps) {
            const { mq, routing } = this.props;
            // refresh initially visible ads as early as possible.  also refresh for media queries
            if (mq !== nextProps.mq) {
                if (!mq) {
                    this.watchAdManager.initAds(nextProps);
                } else {
                    this.watchAdManager.onMediaQueryChange(nextProps);
                }
            }
            const { locationBeforeTransitions: { pathname } } = routing;
            if (pathname !== nextProps.routing.locationBeforeTransitions.pathname) {
                this.watchAdManager.preInit();
            }
        }

        // if this is a HOC of the PageShell, this is only called on route changes
        componentDidUpdate(prevProps) {
            if (prevProps.ads !== this.props.ads) {
                this.watchAdManager.initAds(this.props);
            }
        }

        render() {
            return <WrappedComponent {...this.props} {...this.state} />;
        }
    }

    AdInitializer.propTypes = {
        ads: PropTypes.object,
        mq: PropTypes.string,
        routing: PropTypes.object
    };

    AdInitializer.childContextTypes = {
        watchAdManager: PropTypes.object.isRequired
    };

    const mapStateToProps = (state) => ({
        ads: state.ads,
        mq: state.app.mq,
        routing: state.routing,
        flags: persistentFlagsSelector(state)
    });

    return connect(mapStateToProps)(hoistStatics(AdInitializer, WrappedComponent));
}

export default connectAdInitializer;



// WEBPACK FOOTER //
// ./app/common/ads/connectAdInitializer.js